<template>
	<div class="video__example">
		<div class="video__example-header">
			<UIHeading level="5" class="video__example-header-title">
				{{ $t('pages.publishers.sections.formats.videoContent.example') }}
			</UIHeading>
			<span class="video__example-selected">
				{{ selectedFormat }}
			</span>
		</div>
		<div class="video__example-media">
			<img
				src="/images/pages/publishers/formats/Macbook.png"
				alt="In-Stream Example"
				loading="lazy"
				decoding="async"
				class="video__example-media-img" />
			<div class="video__example-content">
				<Transition name="fade" mode="out-in">
					<img
						v-if="selectedFormatImage"
						:key="selectedFormat"
						:src="selectedFormatImage"
						:alt="`${selectedFormat} Example`"
						loading="lazy"
						decoding="async"
						class="video__example-content-img" />
				</Transition>
			</div>
		</div>
		<div class="video__example-controls">
			<button
				type="button"
				class="video__example-controls-btn"
				aria-label="Предыдущий размер"
				@click="selectPrevFormat">
				<Icon name="mdi:chevron-left" size="28" />
			</button>
			<button
				type="button"
				class="video__example-controls-btn"
				aria-label="Следующий размер"
				@click="selectNextFormat">
				<Icon name="mdi:chevron-right" size="28" />
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
	const props = defineProps<{
		selectedFormat: string
		formats: string[]
	}>()
	const emit = defineEmits<{
		(event: 'change-format', value: string): void
	}>()

	const selectedFormatImage = computed(() => {
		if (props.selectedFormat === 'In-Stream') {
			return '/images/pages/publishers/formats/InStreamVideo.png'
		}
		if (props.selectedFormat === 'Out-Stream') {
			return '/images/pages/publishers/formats/OutStreamVideo.png'
		}
		return ''
	})

	const selectPrevFormat = () => {
		if (!props.formats.length) return
		const currentIndex = props.formats.indexOf(props.selectedFormat)
		const prevIndex = currentIndex <= 0 ? props.formats.length - 1 : currentIndex - 1
		const prevFormat = props.formats[prevIndex]
		if (prevFormat) emit('change-format', prevFormat)
	}

	const selectNextFormat = () => {
		if (!props.formats.length) return
		const currentIndex = props.formats.indexOf(props.selectedFormat)
		const nextIndex =
			currentIndex === -1 || currentIndex >= props.formats.length - 1 ? 0 : currentIndex + 1
		const nextFormat = props.formats[nextIndex]
		if (nextFormat) emit('change-format', nextFormat)
	}
</script>

<style lang="scss" scoped>
	.video__example {
		position: sticky;
		top: 16px;
		width: 100%;

		@media (width <= 767.98px) {
			position: static;
		}
		&-header {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		&-selected {
			padding: 8px 16px;
			background-color: var(--primary);
			border-radius: 40px;
		}
		&-media {
			position: relative;
			display: flex;
			align-items: flex-start;
			margin-top: 32px;
			&-img {
				width: 100%;
				height: 100%;
			}
		}
		&-controls {
			display: flex;
			gap: 12px;
			justify-content: center;
			margin-top: 12px;
			&-btn {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 44px;
				height: 44px;
				background-color: var(--primary);
				border-radius: 999px;
				transition:
					background-color 0.2s ease,
					border-color 0.2s ease;
				&:hover {
					background-color: var(--primary-hover);
				}
			}
		}
		&-content {
			position: absolute;
			bottom: 13%;
			left: 8.5%;
			z-index: 1;
			display: flex;
			gap: 3%;
			width: 83%;
			height: 72%;
			&-img {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>
